import { EmploymentStatus } from 'enums'
import { z } from 'zod'

const cVStepPreferencesSchema = z.object({
  expectedSalaryEuros: z.number(),
  trainingBudgetId: z.string().nullable().optional(),
  remoteWorkTypeId: z.string().nullable().optional(),
  openToPartTime: z.boolean().nullable().optional(),
  bonuses: z.string().array(),
  employmentStatus: z.nativeEnum(EmploymentStatus)
})

export default cVStepPreferencesSchema
